import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Button } from "../../Common";
import styles from "./Customer.module.css";
import { updateCustomer } from "../../api";
import CommentModal from "../../Common/CommentModal/commentModal";
import DropDown from "../../Common/DropDown/index";
import Input from "../../Common/V2/Widgets/Input";
import {objectiveLabels, experienceLabels, riskToleranceLabels, usTaxPayerLabels, experienceOptions, riskToleranceOptions, usTaxPayerOptions, objectivesOptions} from '../../utils/utils';
const InvestingDetail = ({ data, isEditable, refreshDetails, listStatus }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [objective, setObjective] = useState(data.investmentObjectives);
  const [experience, setExperience] = useState(data.investmentExperience);
  const [annual, setAnnual] = useState(data.annual);
  const [netWorth, setNetWorth] = useState(data.netWorth);
  const [totalNetWorth, setTotalNetWorth] = useState(data.totalNetWorth);
  const [riskTolerance, setRiskTolerance] = useState(data.riskTolerance);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isComment, setIsComment] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const initialData = {
    investmentObjectives: data?.investmentObjectives,
    investmentExperience: data?.investmentExperience,
    riskTolerance: data?.riskTolerance,
    annual: data?.annual,
    netWorth: data?.netWorth,
    totalNetWorth: data?.totalNetWorth,
  };


  const updateCustomerDetail = async (custId) => {
    if (loading) return;
    setLoading(true);
    const data = {
      comment: isComment,
      investmentObjectives: objective,
      investmentExperience: experience,
      riskTolerance: riskTolerance,
      annualIncome: annual ? +annual : "",
      networthLiquid: netWorth ? +netWorth : "",
      networthTotal: totalNetWorth ? +totalNetWorth : "",
    };

    try {
      const resp = await updateCustomer(custId, data);
      if (resp?.code === 200) {
        setIsEdit(false);
        setSuccessMessage("Details updated successfully!");
        await refreshDetails();
        setErrorMessage("");
        setTimeout(() => {
          setSuccessMessage("");
          setIsModalOpen(false);
        }, 3000);
      } else {
        setSuccessMessage("");
        setError("");
        setComment("");
        setErrorMessage(resp?.data?.message || "Something went wrong");
        setTimeout(() => {
          setIsModalOpen(false);
        }, 3000);
      }
    } catch (error) {
      setSuccessMessage("");
      setError("");
      setComment("");
      setErrorMessage(error?.response?.data?.message || "Failed to update details");
      setTimeout(() => {
        setIsModalOpen(false);
      }, 3000);
    }
      setLoading(false);
  };

  const handleBackButton = () => {
    setObjective(initialData.investmentObjectives);
    setExperience(initialData.investmentExperience);
    setRiskTolerance(initialData.riskTolerance);
    setAnnual(initialData.annual);
    setNetWorth(initialData.netWorth);
    setTotalNetWorth(initialData.totalNetWorth);
    setIsEdit(false);
  };

  const handleSavebutton = () => {
    setIsModalOpen(true);
    setErrorMessage("");
    setError("");
    setSuccessMessage("");
    setComment("");
  };
  const handleToggleModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div style={{ marginTop: "30px" }}>
      <Row className={styles.detailContainer}>
        <Col className="p-0">Investing Detail</Col>
        {isEditable && listStatus !== "CLOSED" && data?.accountStatus !== "CLOSED" ? (
          <Col
            md={2}
            onClick={() => setIsEdit(true)}
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "end",
            }}
          >
            <div style={{ width: "max-content" }}>
              {isEdit ? (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <Button
                    title="Save"
                    margin={"0px 10px"}
                    disabled={loading}
                    onClick={handleSavebutton}
                  />
                  <Button
                    title="Back"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleBackButton();
                    }}
                  />
                </div>
              ) : (
                "Edit"
              )}
            </div>
          </Col>
        ) : (
          ""
        )}
      </Row>
      {isEdit ? (
        <>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>
             <DropDown
                label="Investment Objective"
                value={objective}
                data={objectivesOptions}
                onChange={(val) => setObjective(val)}
                placeholder="Select Objective"
              />
            </Col>
            <Col className={styles.text}>
             <DropDown
                label="Experience"
                value={experience}
                data={experienceOptions}
                onChange={(val) => setExperience(val)}
                placeholder="Select Experience"
              />
            </Col>
            <Col className={styles.text}>
              <DropDown
                label="Risk Tolerance"
                value={riskTolerance}
                data={riskToleranceOptions}
                onChange={(val) => setRiskTolerance(val)}
                placeholder="Select Risk Tolerance"
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>
              <Input
                label="Annual"
                name="annual"
                type="number"
                min="0"
                value={annual}
                onChange={(e) => setAnnual(e.target.value)}
              />
            </Col>
            <Col className={styles.text}>
              <Input
                label="Net Worth"
                name="netWorth"
                type="number"
                min="0"
                value={netWorth}
                onChange={(e) => setNetWorth(e.target.value)}
              />
            </Col>
            <Col className={styles.text}>
              <Input
                label="Total Net Worth"
                name="totalNetWorth"
                type="number"
                min="0"
                value={totalNetWorth}
                onChange={(e) => setTotalNetWorth(e.target.value)}
              />
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>
              Investing Objective : {objectiveLabels[objective] || "--"}
            </Col>
            <Col className={styles.text}>Experience: {experienceLabels[experience] || "--"}</Col>
            <Col className={styles.text}>
              Risk Tolerance : {riskToleranceLabels[riskTolerance] || "--"}
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>Annual : {annual || "--"}</Col>
            <Col className={styles.text}>Net Worth : {netWorth || "--"}</Col>
            <Col className={styles.text}>
              Total Net Worth : {totalNetWorth || "--"}
            </Col>
          </Row>
        </>
      )}
      <CommentModal
        setIsComment={setIsComment}
        isOpen={isModalOpen}
        onRequestClose={handleToggleModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        errorMessage={errorMessage}
        error={error}
        setError={setError}
        comment={comment}
        setComment={setComment}
        onSave={() => updateCustomerDetail(data.customerId)}
        loading={loading}
      />
    </div>
  );
};

export default InvestingDetail;